import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fba4cfb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fba4cfb0&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=fba4cfb0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba4cfb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba4cfb0')) {
      api.createRecord('fba4cfb0', component.options)
    } else {
      api.reload('fba4cfb0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fba4cfb0&scoped=true", function () {
      api.rerender('fba4cfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/index.vue"
export default component.exports